export default {
  standard: 'standard',
  provider: 'provider',
  support: 'support',
};